/* component-offer-countdown.js */
(() => {
  "use strict";

  // --- Asetukset ja valinnat ---
  const ROOT_SELECTORS = [
    '[data-sale-validity-date]',
    '[data-metafield*="sale_validity_date"]',
    '.product-block.product-block__text .rte',
    '.product__description .rte',
    '.product__description',
    '.product__info-container .rte',
    '.product__accordion .rte',
    '.product__accordion',
    '.rte'
  ];

  const DATE_REGEX = /^\s*(\d{1,2})\.(\d{1,2})\.(\d{2}|\d{4})\s*$/;
  const COUNTDOWN_THRESHOLD_MS = 48 * 60 * 60 * 1000; // 48 h

  // --- CSS class (ajastin-tila) ---
  const TIMER_CLASS = "fl-offer-countdown--timer";

  function setTimerClass(el, on) {
    if (!el || !el.classList) return;
    if (on) el.classList.add(TIMER_CLASS);
    else el.classList.remove(TIMER_CLASS);
  }

  // --- Sivukonteksti ---
  function isProductPage() {
    return (
      location.pathname.includes("/products/") ||
      document.body.classList.contains("template-product") ||
      ((document.documentElement.getAttribute("data-template") || "").includes("product"))
    );
  }

  // --- Kampanja-guard ---
  let _campaignActiveCache = false;

  function computeCampaignActive() {
    if (document.querySelector('[data-campaign-active="1"]')) return true;

    const root = document.querySelector("main") || document.querySelector("#MainContent") || document.body;
    const txt = (root && (root.textContent || "")) || "";
    return txt.toLowerCase().includes("kampanja voimassa");
  }

  function isCampaignActive() {
    return _campaignActiveCache;
  }

  // --- Apufunktiot ---
  function parseFinnishDate(str) {
    const m = str.match(DATE_REGEX);
    if (!m) return null;
    let [, d, mo, y] = m;
    const day = parseInt(d, 10);
    const month = parseInt(mo, 10);
    let year = parseInt(y, 10);
    if (year < 100) year += 2000;
    if (month < 1 || month > 12) return null;

    const end = new Date(year, month - 1, day, 23, 59, 59, 999);
    if (end.getFullYear() !== year || end.getMonth() + 1 !== month || end.getDate() !== day) return null;
    return end;
  }

  const fiPlural = (n, singular, plural) => (n === 1 ? singular : plural);

  function joinFi(parts) {
    if (!parts.length) return "";
    if (parts.length === 1) return parts[0];
    if (parts.length === 2) return parts[0] + " ja " + parts[1];
    return parts.slice(0, -1).join(", ") + " ja " + parts[parts.length - 1];
  }

  function fmtDurationHM(ms) {
    if (ms <= 0) return null;
    const totalSeconds = Math.floor(ms / 1000);
    const totalHours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    if (totalHours === 0 && minutes === 0 && totalSeconds > 0) return "alle minuutti";

    const parts = [];
    if (totalHours > 0) parts.push(`${totalHours} ${fiPlural(totalHours, "tunti", "tuntia")}`);
    if (minutes > 0) parts.push(`${minutes} ${fiPlural(minutes, "minuutti", "minuuttia")}`);
    return parts.length ? joinFi(parts) : null;
  }

  function isTimerMode(diffMs) {
    return diffMs > 0 && diffMs <= COUNTDOWN_THRESHOLD_MS;
  }

  function buildMessageHTML(diffMs, originalDateStr) {
    const iconHtml = '<span class="price-validity-note__icon" aria-hidden="true"><svg viewBox="0 0 20 20" fill="none" focusable="false" aria-hidden="true"><circle cx="10" cy="10" r="8.25" stroke="currentColor" stroke-width="1.5"></circle><path d="M10 5.5V10L13 11.8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>';
    // Kun tarjous on päättynyt -> EI näytetä mitään tekstiä (piilotus hoidetaan updateNode:ssa)
    if (diffMs <= 0) return null;

    // Yli 48h -> näytetään "Tarjous voimassa pvm asti"
    if (diffMs > COUNTDOWN_THRESHOLD_MS) return `${iconHtml}<span class="price-validity-note__text">Tarjous voimassa ${originalDateStr} asti.</span>`;

    // 0..48h -> ajastinmuoto
    const durationStr = fmtDurationHM(diffMs);
    if (!durationStr) return `${iconHtml}<span class="price-validity-note__text">Tarjous voimassa ${originalDateStr} asti.</span>`;
    return `${iconHtml}<span class="price-validity-note__text">Tarjous voimassa ${durationStr}.<br> Tilaa viimeistään ${originalDateStr} mennessä.</span>`;
  }

  function getEndDateFromElement(el) {
    const dataAttr = el.getAttribute?.("data-sale-validity-date");
    if (dataAttr) {
      const d = parseFinnishDate(String(dataAttr).trim());
      if (d) return { end: d, original: String(dataAttr).trim() };
    }

    const text = (el.textContent || "").trim();
    if (DATE_REGEX.test(text)) {
      const d = parseFinnishDate(text);
      if (d) return { end: d, original: text };
    }
    return null;
  }

  function ensureNodeState(el) {
    if (el.dataset._flOfferProcessed === "1") return true;
  
    const parsed = getEndDateFromElement(el);
    if (!parsed) return false;
  
    // Tallennetaan alkuperäinen sisältö ja display, jotta voidaan palauttaa/tehdä piilotus siististi
    if (!el.hasAttribute("data-original-html")) {
      el.setAttribute("data-original-html", el.innerHTML);
    }
    if (!el.hasAttribute("data-original-display")) {
      el.setAttribute("data-original-display", el.style.display || "");
    }
  
    el.setAttribute("data-original-date", parsed.original);
    el.setAttribute("data-end-ts", String(parsed.end.getTime()));
    el.dataset._flOfferProcessed = "1";
    return true;
  }
  
  function updateNode(el) {
    if (!ensureNodeState(el)) return;
  
    const endTs = Number(el.getAttribute("data-end-ts"));
    const originalDate = el.getAttribute("data-original-date") || "";
    const diff = endTs - Date.now();
  
    // Kun tarjous on päättynyt -> palautetaan alkuperäinen HTML (ettei jää “päättynyt”-tekstejä DOMiin)
    // ja piilotetaan elementti kokonaan.
    if (diff <= 0) {
      setTimerClass(el, false);
  
      const originalHtml = el.getAttribute("data-original-html");
      if (typeof originalHtml === "string" && el.innerHTML !== originalHtml) {
        el.innerHTML = originalHtml;
      }
  
      if (el.dataset._flHiddenByExpiry !== "1") {
        el.dataset._flPrevDisplayExpiry = el.style.display || "";
        el.style.display = "none";
        el.dataset._flHiddenByExpiry = "1";
      }
      return;
    }
  
    // Tarjous on voimassa -> varmistetaan näkyvyys
    if (el.dataset._flHiddenByExpiry === "1") {
      el.style.display =
        el.getAttribute("data-original-display") ||
        el.dataset._flPrevDisplayExpiry ||
        "";
      delete el.dataset._flPrevDisplayExpiry;
      delete el.dataset._flHiddenByExpiry;
    }
  
    const html = buildMessageHTML(diff, originalDate);
  
    // Ajastinluokka vain kun tunti/minuutti -laskuri on käytössä
    setTimerClass(el, isTimerMode(diff));
  
    if (html != null && el.innerHTML !== html) el.innerHTML = html;
  }
  

  // --- Kandidaatit (ilman kampanja-guardia) ---
  // --- Kandidaatit (kaikki) ---
  function getOfferDateCandidatesAll() {
    const set = new Set();
  
    document
      .querySelectorAll('[data-sale-validity-date], [data-metafield*="sale_validity_date"]')
      .forEach((el) => set.add(el));
  
    for (const rootSel of ROOT_SELECTORS) {
      document.querySelectorAll(rootSel).forEach((root) => {
        root.querySelectorAll("p, span, div").forEach((node) => {
          const txt = (node.textContent || "").trim();
          if (DATE_REGEX.test(txt)) set.add(node);
        });
      });
    }
  
    return Array.from(set);
  }
  
  function hideByOfferPrimary(el) {
    if (!el) return;
    if (el.dataset._flHiddenByOfferPrimary === "1") return;
    el.dataset._flPrevDisplayOfferPrimary = el.style.display || "";
    el.style.display = "none";
    el.dataset._flHiddenByOfferPrimary = "1";
  }
  
  function restoreHiddenByOfferPrimary(el) {
    if (!el) return;
    if (el.dataset._flHiddenByOfferPrimary === "1") {
      el.style.display = el.dataset._flPrevDisplayOfferPrimary || "";
      delete el.dataset._flPrevDisplayOfferPrimary;
      delete el.dataset._flHiddenByOfferPrimary;
    }
  }
  
  // --- Kandidaatit (PDP:llä valitaan vain yksi, jotta ei tule duplikaatteja) ---
  function getOfferDateElementsRaw() {
    // 1) Preferoi eksplisiittistä data-attribuuttia
    const explicitSale = Array.from(document.querySelectorAll('[data-sale-validity-date]'));
    const explicitMf = Array.from(document.querySelectorAll('[data-metafield*="sale_validity_date"]'));
  
    let chosen = null;
  
    if (explicitSale.length) {
      // Preferoi offer-countdown -aluetta (sinun renderöimä div)
      const preferred = explicitSale.find((el) => el.classList?.contains("offer-countdown") || el.closest?.(".offer-countdown"));
      chosen = preferred || explicitSale[0];
    } else if (explicitMf.length) {
      chosen = explicitMf[0];
    } else {
      // 2) Fallback: etsi vain ensimmäinen “paljas päivämäärä”
      const all = getOfferDateCandidatesAll();
      if (all.length) chosen = all[0];
    }
  
    // Piilota muut tarjous-kandidaatit (duplikaattien esto)
    const allCandidates = getOfferDateCandidatesAll();
    allCandidates.forEach((el) => {
      if (chosen && el === chosen) restoreHiddenByOfferPrimary(el);
      else hideByOfferPrimary(el);
    });
  
    return chosen ? [chosen] : [];
  }

  // --- Kampanjassa piilotetaan käyttäjävirhe: sale_validity_date -päivämäärärivi ---
  function hideOfferDateNodesBecauseCampaign() {
    const els = getOfferDateCandidatesAll();
    els.forEach((el) => {
      const hasAttr =
        el.matches?.('[data-sale-validity-date]') ||
        el.matches?.('[data-metafield*="sale_validity_date"]');
  
      const txt = (el.textContent || "").trim();
      const isBareDate = DATE_REGEX.test(txt);
  
      if (!hasAttr && !isBareDate) return;
      if (el.dataset._flHiddenByCampaign === "1") return;
  
      el.dataset._flPrevDisplay = el.style.display || "";
      el.style.display = "none";
      el.dataset._flHiddenByCampaign = "1";
    });
  }
  
  function restoreOfferDateNodesIfNeeded() {
    getOfferDateCandidatesAll().forEach((el) => {
      if (el.dataset._flHiddenByCampaign === "1") {
        el.style.display = el.dataset._flPrevDisplay || "";
        delete el.dataset._flPrevDisplay;
        delete el.dataset._flHiddenByCampaign;
      }
    });
  }
  
  function hasActiveOfferNow() {
    const els = getOfferDateElementsRaw();
    let active = false;
  
    for (const el of els) {
      if (!ensureNodeState(el)) continue;
      const endTs = Number(el.getAttribute("data-end-ts"));
      if (endTs - Date.now() > 0) {
        active = true;
        break;
      }
    }
    return active;
  }
  
  function scanAndInit() {
    _campaignActiveCache = computeCampaignActive();
  
    // Jos kampanja on päällä mutta SALE on myös voimassa -> EI piiloteta,
    // vaan annetaan countdownin toimia normaalisti.
    const offerActive = hasActiveOfferNow();
  
    if (isCampaignActive() && !offerActive) {
      hideOfferDateNodesBecauseCampaign();
      return;
    }
  
    restoreOfferDateNodesIfNeeded();
    getOfferDateElementsRaw().forEach(ensureNodeState);
  }
  
  function tick() {
    _campaignActiveCache = computeCampaignActive();
  
    const offerActive = hasActiveOfferNow();
  
    if (isCampaignActive() && !offerActive) {
      hideOfferDateNodesBecauseCampaign();
      return;
    } else {
      restoreOfferDateNodesIfNeeded();
    }
  
    getOfferDateElementsRaw().forEach(updateNode);
  }
  
  function scheduleMinuteTicker() {
    const now = new Date();
    const msToNextMinute = (60 - now.getSeconds()) * 1000 - now.getMilliseconds();
    setTimeout(() => {
      tick();
      setInterval(tick, 60 * 1000);
    }, Math.max(0, msToNextMinute));
  }

  function releaseProductPaintGate() {
    if (typeof window.__pdpOfferPendingRelease === "function") {
      window.__pdpOfferPendingRelease();
    } else {
      const root = document.documentElement;
      root.classList.remove("pdp-offer-pending");
      root.removeAttribute("data-pdp-offer-pending");
    }

    if (window.__pdpOfferPendingTimeout) {
      clearTimeout(window.__pdpOfferPendingTimeout);
      window.__pdpOfferPendingTimeout = null;
    }
  }

  // --- Käynnistys ---
  function initOnce() {
    if (!isProductPage()) return;
    if (document.documentElement.dataset.flOfferCountdownInit === "1") return;
    document.documentElement.dataset.flOfferCountdownInit = "1";

    scanAndInit();
    tick();
    releaseProductPaintGate();
    scheduleMinuteTicker();

    const mo = new MutationObserver(() => {
      scanAndInit();
      tick();
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener(
      "shopify:section:load",
      () => {
        scanAndInit();
        tick();
      },
      { passive: true }
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initOnce, { once: true });
  } else {
    initOnce();
  }
})();
